import React, { useState, useRef, useEffect, memo, useCallback } from "react";
import "react-simple-keyboard/build/css/index.css";
import Styles from "./giftCard.module.scss";
import cn from "classnames";
import { LABEL, CUSTOM_MESSAGES } from "../../veriables";
import { flowType } from "@utility/userInfo";
import Keyboard from "@components/KeyboardV2";
import { APP_CONFIG } from "@constants";
import { getObjectValue, urlSearchParams } from "../../utility/utills";
import Webcam from "react-webcam";
import Modal from "../common/Modal/index";
import FullWithModal from "../common/Modal/FullWidthModal";
import GiftCardImage from "@assets/images/gift_card.png";
import GiftCardImageWhite from "@assets/images/GiftCardImageWhite.png";
import { ReactComponent as Cross } from "@assets/images/cross.svg";
import { TouchableButton, TouchableDiv } from '@components/common/Touchable';
import GiftCardBalanceScreen from './GiftCardBalanceScreen';
import GiftCardLandscapeMode from './GiftCardLandscapeMode';
import { connect } from "react-redux";

const giftCard = (props) => {
  const {
    // type,
    isSecurityCode,
    onSubmit,
    giftBalance,
    giftCardPayment,
    paymentAmount,
    giftCardSupportsSwipe,
    openCardPopUp,
    handleGiftCancel,
    setPaymentType,
    tableData,
    setNotification,
    authInfo,
    serverAppTheme,
    setPayModeType,
    isSwipe,
    giftCardBalanceInfo,
    giftCardBalanceCheck,
    giftCardNumber,
    showCheckSeat,
    paymentLandscapeOrientation,
  } = props;
  const [activeElement, setActiveElement] = useState("cardNumber");
  const [inputs, setInputs] = useState("");
  const [typed, setTyped] = useState({});
  const typedRef = useRef(typed);
  typedRef.current = typed;
  const inputsRef = useRef(inputs);
  inputsRef.current = inputs;
  const currencySymbol = LABEL().CURRENCY_SYMBOL;
  const [swipedDown, setSwipedDown] = useState(true);
  const [error, setError] = useState("");
  const [isWebCam, setIsWebCam] = useState(false);
  const [clickToType, setClickToType] = useState(false);
  const [showBalanceScreen, setShowBalanceScreen] = useState(false);
  const keyboard = useRef(null);
  const ref = useRef(null);
  const previousBalanceInfoRef = useRef(null);
  const showCheckSeatVar = showCheckSeat();
  const giftCardImageUrl = getObjectValue(
    () => authInfo.giftCardImageUrl,
    null,
  );
  const isServerApp = flowType() === "serverApp";
  const getTheme = getObjectValue(
    () => JSON.parse(window.sessionStorage.getItem("auth")).serverAppTheme,
  );

  useEffect(() => {
    handleGiftCancel?.(true);

    setShowBalanceScreen(false);
    setInputs({ cardNumber: "", securityCode: "", giftCard: "" });
    setTyped({ cardNumber: "", securityCode: "", giftCard: "" });
    previousBalanceInfoRef.current = null;
  }, []);

  useEffect(() => {
    setActiveElement(!giftBalance ? activeElement : "giftCard");
    if (paymentAmount) {
      setInputs({
        ...inputs,
        giftCard: `${Number(paymentAmount).toFixed(2)}`,
      });
      setTyped({
        ...typed,
        giftCard: `${Number(paymentAmount).toFixed(2)}`,
      });
    }
  }, [giftBalance, swipedDown]);

  useEffect(() => {
    if (giftCardBalanceInfo?.accountNumber) {
      const isNewBalanceInfo =
        !previousBalanceInfoRef.current ||
        previousBalanceInfoRef.current.accountNumber !== giftCardBalanceInfo.accountNumber;

      if (isNewBalanceInfo) {
        setShowBalanceScreen(true);
        previousBalanceInfoRef.current = giftCardBalanceInfo;
      }
    } else if (!giftCardBalanceInfo && previousBalanceInfoRef.current) {
      setShowBalanceScreen(false);
      previousBalanceInfoRef.current = null;
    }
  }, [giftCardBalanceInfo]);

  const handleClickOutside = (e) => {
    if (ref.current && !ref.current.contains(e.target)) {
    }
  };
const handleErrorPopUp = (message) => {
  props.setErrorPopUp({
    res: message,
    noErrorTxt: true,
  });
};

  const onClickBtn = useCallback((e) => {
    setError("");
    const currentTyped = typedRef.current;
    const currentInputs = inputsRef.current;
    setTyped(
      e === "{bksp}"
        ? { ...currentTyped, [activeElement]: currentTyped[activeElement]?.slice(0, -1) }
        : {
            ...currentTyped,
            [activeElement]: currentTyped[activeElement]
              ? currentTyped[activeElement].concat(e)
              : "".concat(e),
          },
    );
    const value =
      e === "{bksp}"
        ? { ...currentTyped, [activeElement]: currentTyped[activeElement]?.slice(0, -1) }
        : {
            ...currentTyped,
            [activeElement]: currentTyped[activeElement]
              ? currentTyped[activeElement].concat(e)
              : "".concat(e),
          };
    setInputs({
      ...currentInputs,
      [activeElement]: value[activeElement],
    });
  }, [activeElement]);

  const handleSetInputEmpty = useCallback(() => {
    setInputs((prev) => ({ ...prev, [activeElement]: "" }));
    setTyped((prev) => ({ ...prev, [activeElement]: "" }));
  }, [activeElement]);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleBlur = () => {
    if (document.querySelector("#cardNumber")) {
      document.querySelector("#cardNumber").blur();
    }
    if (document.querySelector("#securityCode")) {
      document.querySelector("#securityCode").blur();
    }
  };

  const handleBlurForGift = () => {
    document.querySelector("#giftCard").blur();
  };

  const setEmpty = (data) => {
    setInputs({
      ...inputs,
      [data]: "",
    });
    setTyped({
      ...typed,
      [data]: "",
    });
  };

  const handleChangeInput = (data) => {
    if (keyboard.current) {
      keyboard.current.setInput(inputs[data], data);
    }
  };
  const validate = () => {
    const giftCardAmount = Number(inputs?.giftCard);
    let giftError = "";
    if (!giftCardAmount) {
      giftError = "Enter amount more than 0";
    } else if (
      +paymentAmount.toFixed(2) < +giftCardAmount.toFixed(2) ||
      Number(giftCardAmount) === 0
    ) {
      giftError = "Enter the correct total amount";
    } else if (Number(giftBalance) < Number(giftCardAmount)) {
      giftError = "Entered amount should be less than balance";
    }
    setError(giftError);
    if (giftError.length === 0) {
      setError("");
      giftCardPayment(giftCardAmount);
    }
  };


  const getInput = (key) => {
    return inputs[key];
  };

  const handleDisable = () =>
    !inputs?.cardNumber || (isSecurityCode && !inputs?.securityCode);

  const handleDisableGiftCard = () => {
    return !inputs?.giftCard;
  };

  const type = urlSearchParams('type');

  const handleBackButton = () => {
    const screenType = type === "giftCardPay" ? 32 : 31;
    const typeParam = urlSearchParams("ticketSplitTypeId") === "1" ? "payType" : "splitType";

    return {
      isShow: true,
      url: () => {
        setPaymentType(type === "giftCardPay" ? 32 : 31);
        setPayModeType(LABEL().DEFAULT_PAY);
        props.navigate(
          `${APP_CONFIG.BASE_URL}/receipt/${tableData.id}?ticketSplitTypeId=${urlSearchParams("ticketSplitTypeId")}&splitValue=${urlSearchParams("splitValue")}&screenType=${screenType}&type=${typeParam}`,
          { replace: true }
        );
      },
    };
  };

  const imageSubmit = (jsonToSend) => {
    props
      .giftCardImages(JSON.stringify(jsonToSend))
      .then((res) => {
        setInputs({
          giftCard: "",
          cardNumber: res.accountNumber,
          securityCode: res.securityCode,
        });
      })
      .catch((err) => {
        setNotification({
          type: "danger",
          message: err.message,
        });
      });
  };

  const videoConstraints = {
    width: 320,
    height: 200,
    facingMode: "environment",
  };

  const WebcamCapture = () => (
    <Webcam
      audio={false}
      height={350}
      screenshotFormat="image/jpeg"
      width={500}
      videoConstraints={videoConstraints}
    >
      {({ getScreenshot }) => (
        <button
          type="button"
          onClick={() => {
            // const imageSrc = getScreenshot()
            setIsWebCam(false);
            const jsonToSend = {
              bytes: getScreenshot().split("base64,")[1],
            };
            imageSubmit(jsonToSend);
          }}
          style={{ position: "relative", bottom: "0vh", width: "100%" }}
          className="border-0 btn btn-primary"
        >
          Capture photo
        </button>
      )}
    </Webcam>
  );
  if (showBalanceScreen && giftCardBalanceInfo) {
    return (
      <GiftCardBalanceScreen
        giftCardInfo={giftCardBalanceInfo}
        onDontUse={() => {
          setShowBalanceScreen(false);
          setInputs({ cardNumber: "", securityCode: "", giftCard: "" });
          setTyped({ cardNumber: "", securityCode: "", giftCard: "" });
          previousBalanceInfoRef.current = null;
          handleGiftCancel(true);
        }}
        onRedeem={() => {

          const applyData = {
            cardNumber: giftCardBalanceInfo.accountNumber,
            ...(isSecurityCode && giftCardBalanceInfo.securityCode ? { securityCode: giftCardBalanceInfo.securityCode } : {}),
            method: giftCardBalanceInfo?.method || giftCardNumber?.method || 'type',
            paymentAmount: giftCardBalanceInfo?.paymentAmount,
            fromBalanceScreen: true
          };
          onSubmit(applyData);
        }}
        serverAppTheme={serverAppTheme}
        currencySymbol={currencySymbol}
        landscapePaymentMode={paymentLandscapeOrientation}
        showCheckSeat={showCheckSeat}
      />
    );
  }

  if (!giftBalance && paymentLandscapeOrientation && !isSwipe) {
    return <GiftCardLandscapeMode {...props} showCheckSeat={showCheckSeat} />;
  }

  return !giftBalance ? (
    <>
    {!isSwipe &&
    <div
      ref={ref}
      className={cn("col-12 w-100 h-100 px-0")}
    >
      <div className={cn("px-0 h-90")}>
        {giftCardImageUrl !== null ? (
          <div
            style={{ height: "22%" }}
            className={cn(
              "px-3 pt-1 fs-22 large-input row justify-content-center",
            )}
          >
            <img
              src={giftCardImageUrl}
              alt="giftCardImage"
              style={{ objectFit: "cover", width: "100%", height: "100%" }}
            />
          </div>
        ) : (
          <div
            style={{ height: "22%" }}
            className={cn(
              "col-12 px-0 pb-1 pt-2 justify-content-center",
            )}
          >
            <img
              src={getTheme === "2" ? GiftCardImageWhite : GiftCardImage}
              style={{ objectFit: "cover", width: "100%", height: "100%" }}
              alt="GiftCardImage"
            />
          </div>
        )}
        {giftCardSupportsSwipe && (
          <div
            className="d-flex px-0 flex-column align-items-center col-12 mt-1"
            style={{ height: "3.5rem" }}
          >
            <TouchableButton
              type="submit"
              className={cn(
                "w-100 col-12 btn-ripple text-center fs_24 fw-600 rounded border-0 text-white od-primary-btn-bg-color od-primary-btn-font-color",
              )}
              style={{
                backgroundColor: serverAppTheme?.secondaryBtn,
              }}
              onClick={(e) => {
                e.preventDefault();
                openCardPopUp();
                setSwipedDown(false);
              }}
              rippleEffect={true}
            >
              {LABEL().GS_CLICK_TO_SWIPE_CARD}
            </TouchableButton>
          </div>
        )}

        {giftCardSupportsSwipe && (
          <div className="fs_20 h-8 fw-600 col-12 px-0 d-flex align-items-center justify-content-center text-center">
            {" "}
            <span> OR </span>
          </div>
        )}
        <div className="col-12 mb-1 mx-0 position-relative p-0">
          <div className={cn("d-flex flex-row align-items-center ")}>
            <div
              className={cn(
                "col-12 p-0 fs-22 row mx-0 justify-content-center roundedSm",
              )}
            >
              <input
                value={getInput("cardNumber")}
                className={cn("form-control fs_18 fw-400")}
                type="text"
                style={{
                  height: "3.5rem",
                  border: "none",
                  background: serverAppTheme?.inputBg,
                  borderBottom: serverAppTheme?.inputBorder_Bottom,
                  color: serverAppTheme?.primary_text,
                  borderRadius: "0",
                  "--placeholder-color": serverAppTheme?.input_placeholder,
                }}
                id="cardNumber"
                name="cardNumber"
                onFocus={() => {
                  handleChangeInput("securityCode");
                  setActiveElement("cardNumber");
                  handleBlur();
                }}
                placeholder={LABEL().GS_CLICK_TO_ENTER_CARD_NUMBER}
              />

              {inputs?.cardNumber?.length > 0 && (
                <TouchableDiv
                  role="presentation"
                  className="position-absolute"
                  style={{
                    top: "50%",
                    right: "1%",
                    transform: "translateY(-50%)",
                  }}
                  onClick={() => {
                    handleGiftCancel(false);
                    setEmpty("cardNumber");
                    setActiveElement("cardNumber");
                  }}
                >
                  <Cross fill={serverAppTheme?.iconcolor} />
                </TouchableDiv>
              )}
            </div>
          </div>

          {isSecurityCode && (
            <TouchableDiv
              className={cn(
                "col-12 mt-3 p-0 fs-22 row mx-0 justify-content-center roundedSm",
              )}
            >
              <input
                value={getInput("securityCode")}
                className={cn("form-control fs_18 fw-400")}
                type="text"
                style={{
                  height: "3.5rem",
                  border: "none",
                  background: serverAppTheme?.inputBg,
                  borderBottom: serverAppTheme?.inputBorder_Bottom,
                  color: serverAppTheme?.primary_text,
                  borderRadius: "0",
                  "--placeholder-color": serverAppTheme?.input_placeholder,
                }}
                id="securityCode"
                name="securityCode"
                onFocus={() => {
                  handleChangeInput("securityCode");
                  setActiveElement("securityCode");
                  handleBlur();
                }}
                placeholder={LABEL().GS_CLICK_TO_ENTER_SECURITY_CODE}
              />
              {inputs?.securityCode?.length > 0 && (
                <TouchableDiv
                  role="presentation"
                  className="position-absolute"
                  style={{
                    top: "50%",
                    right: "1%",
                    transform: "translateY(-50%)",
                  }}
                  onClick={() => {
                    handleGiftCancel(false);
                    setEmpty("securityCode");
                    setActiveElement("securityCode");
                  }}
                >
                  <Cross fill={serverAppTheme?.iconcolor} />
                </TouchableDiv>
              )}
            </TouchableDiv>
          )}
        </div>
        <div
          className={cn(
            "p-1 od-border-secondary",
            cn("w-100", Styles.paymentTerminal),
          )}
        >
            <Keyboard
              onClickBtn={onClickBtn}
              type="numericDefaultWithDone"
              customClass="fs-30 pt-1 pl-1 pb-3"
              maxLength={30}
              setinputEmpty={handleSetInputEmpty}
            />
        </div>
      </div>
      <div
            className={cn(
              "col-12 px-0 h-10 position-absolute d-flex align-items-end justify-content-between",
              showCheckSeatVar && !paymentLandscapeOrientation ? Styles.gftcardbtnAllgn : Styles.gftcardbtnAllgn2,
            )}
            // style={{
            //   bottom:"0"
            // }}
      >
        <TouchableButton
          type="submit"
          className={cn("btn-ripple fs_28 fw-600 od-cancel-btn-bg-color od-cancel-btn-font-color od-cancel-btn-st-color", Styles.giftCardBtnPrimary)}
          style={{
            fontFamily: "Poppins",
            borderRadius: "4px",
            border: "1px solid #2541A4",
            height: "7.7vh",
            backgroundColor: serverAppTheme?.OFF_Premise_Btn,
            color: serverAppTheme?.primary_text,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={(e) => {
            e.preventDefault();
            window.sessionStorage.removeItem('giftCardpayment');
            handleBackButton().url()
          }}
          rippleEffect={true}
        >
          {LABEL().GS_CANCEL}
        </TouchableButton>
        <TouchableButton
          type="submit"
          className={cn(
            "btn-ripple fs_28 fw-600",
            "od-primary-btn-bg-color od-primary-btn-font-color",
            Styles.giftCardBtnPrimary
          )}
          style={{
            fontFamily: "Poppins",
            borderRadius: "4px",
            border: "none",
            height: "7.7vh",
            background: serverAppTheme?.secondaryBtn,
            color: serverAppTheme?.btn_font_color,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            lineHeight: "1.2",
            padding: "0.5rem",
          }}
  onClick={(e) => {
    e.preventDefault();
  if (!inputs?.cardNumber || inputs?.cardNumber.length <= 0) {
    handleErrorPopUp(CUSTOM_MESSAGES().PLEASE_ENTER_THE_CARD_NUMBER);
    return;
  }

  if (isSecurityCode && (!inputs?.securityCode || inputs?.securityCode.length <= 0)) {
    handleErrorPopUp(CUSTOM_MESSAGES().PLEASE_ENTRE_THE_SECURITY_CODE);
    return;
  }

  if (giftCardBalanceCheck) {
    const balanceCheckData = {
      accountNumber: inputs.cardNumber,
      ...(isSecurityCode && inputs.securityCode ? { securityCode: inputs.securityCode } : {}),
      method: giftCardNumber?.method || 'type'
    };
    previousBalanceInfoRef.current = null;
    giftCardBalanceCheck(balanceCheckData);
  } else {
    onSubmit({ ...inputs, method: giftCardNumber?.method || 'type' });
  }
}}

          rippleEffect={true}
        >
          {LABEL().OS_ADD_A_GIFT_CARD || 'Add a Gift Card'}
        </TouchableButton>
      </div>
      <Modal isOpen={isWebCam} isModalCenter>
        <div className="p-2 justify-content-center align-items-center text-center">
          <div className={cn("px-2 text-right")}>
            <i
              role="presentation"
              className={cn("fa fa-times fs-24")}
              onClick={() => setIsWebCam(!isWebCam)}
            />
          </div>
          {isWebCam ? <WebcamCapture /> : <></>}
        </div>
      </Modal>
      <FullWithModal
        isOpen={clickToType}
        noBackground
        customClass2={cn("m-auto col-12 w-100 h-100 p-3")}
        style={{
          width: "100%",
          backgroundColor: serverAppTheme?.popUp_bg,
          border: serverAppTheme?.popupBorder,
          boxShadow: serverAppTheme?.popUp_box_shadow,
          height: "100%",
          borderRadius: "16px",
        }}
      >
        <div
          className="position-absolute"
          style={{ top: "23px", right: "23px", zIndex: "999" }}
        >
          <Cross
            fill={serverAppTheme?.iconcolor}
            role="presentation"
            onClick={() => setClickToType(!clickToType)}
          />
        </div>
        <div
          className="w-100 h-100 position-relative"
          style={{ color: serverAppTheme?.primary_text }}
        >
          <div className=" h-100 p-2 m-0">
            <div
              className=" py-4 text-center h-10  fw-600 fs_32"
              style={{ fontFamily: "Poppins", marginTop: "15%" }}
            >
              Enter Details
            </div>
            <div className={cn("col-12 px-1 position-relative my-2 h-8")}>
              <input
                value={getInput("cardNumber")}
                className={cn(
                  "form-control fs_26 fw-400 ",
                  Styles.borderBottomIn,
                )}
                type="text"
                style={{
                  height: "6.5vh",
                  borderBottom: serverAppTheme?.inputBorder_Bottom,
                  backgroundColor: serverAppTheme?.inputBg,
                  color: serverAppTheme?.primary_text,
                  "--placeholder-color": serverAppTheme?.input_placeholder,
                  fontFamily: "Poppins",
                  borderRadius: "0%",
                  border: "none",
                }}
                id="cardNumber"
                name="cardNumber"
                onFocus={() => {
                  handleChangeInput("securityCode");
                  setActiveElement("cardNumber");
                  handleBlur();
                }}
                placeholder={LABEL().GS_CLICK_TO_ENTER_CARD_NUMBER}
              />
              {inputs?.cardNumber?.length > 0 && (
                <div
                  role="presentation"
                  className="position-absolute"
                  style={{
                    top: "44%",
                    right: "2%",
                    transform: "translateY(-50%)",
                  }}
                  onClick={() => {
                    handleGiftCancel(false);
                    setEmpty("cardNumber");
                    setActiveElement("cardNumber");
                  }}
                >
                  <Cross fill={serverAppTheme?.iconcolor} alt="clear" />
                </div>
              )}
            </div>
            {isSecurityCode && (
              <div className={cn("col-12 px-1 position-relative my-2 h-8")}>
                <input
                  value={getInput("securityCode")}
                  className={cn(
                    "form-control fs_26 fw-400 ",
                    Styles.borderBottomIn,
                  )}
                  type="text"
                  style={{
                    height: "6.5vh",
                    borderBottom: serverAppTheme?.inputBorder_Bottom,
                    backgroundColor: serverAppTheme?.inputBg,
                    color: serverAppTheme?.primary_text,
                    "--placeholder-color": serverAppTheme?.input_placeholder,
                    fontFamily: "Poppins",
                    borderRadius: "0%",
                    border: "none",
                  }}
                  id="securityCode"
                  name="securityCode"
                  onFocus={() => {
                    handleChangeInput("securityCode");
                    setActiveElement("securityCode");
                  }}
                  placeholder={LABEL().GS_CLICK_TO_ENTER_SECURITY_CODE}
                />
                {inputs?.securityCode?.length > 0 && (
                  <div
                    role="presentation"
                    className="position-absolute"
                    style={{
                      top: "44%",
                      right: "2%",
                      transform: "translateY(-50%)",
                    }}
                    onClick={() => {
                      handleGiftCancel(false);
                      setEmpty("securityCode");
                      setActiveElement("securityCode");
                    }}
                  >
                    <Cross fill={serverAppTheme?.iconcolor} alt="clear" />
                  </div>
                )}
              </div>
            )}
            <div
              style={{ bottom: "10%", left: "0" }}
              className={cn(
                "col-12 px-0 h-48 position-absolute d-flex justify-content-center align-items-center",
              )}
            >
              {
                <div className={cn("p-0 h-100", cn("w-100"))}>
                    <Keyboard
                      onClickBtn={onClickBtn}
                      type="numericWithBin"
                      btnSize="btn35"
                      customClass="pl-1"
                      maxLength={30}
                      setinputEmpty={handleSetInputEmpty}
                      screenType="giftCard"
                    />
                </div>
              }
            </div>
            <div
              className="col-12 h-10 position-absolute px-1 d-flex justify-content-center align-items-center"
              style={{ bottom: "0", left: "0" }}
            >
              <button
                type="submit"
                className={cn(
                  "w-95 btn70 btn btn-ripple ",
                  Styles.giftCardBtnSecondary,
                )}
                disabled={handleDisable()}
                style={{
                  fontFamily: "Poppins",
                  fontSize: isServerApp ? "1.75rem" : "1.8rem",
                  fontWeight: "600",
                  height: "7.5vh",
                  background: serverAppTheme?.secondaryBtn,
                }}
                onClick={() => {
                  if (giftCardBalanceCheck) {
                    const balanceCheckData = {
                      accountNumber: inputs.cardNumber,
                      ...(isSecurityCode && inputs.securityCode ? { securityCode: inputs.securityCode } : {}),
                      method: giftCardNumber?.method || 'type'
                    };
                    previousBalanceInfoRef.current = null;
                    giftCardBalanceCheck(balanceCheckData);
                    setClickToType(!clickToType);
                  } else {
                    onSubmit({ ...inputs, method: giftCardNumber?.method || "type" });
                    setClickToType(!clickToType);
                  }
                }}
              >
                {LABEL().CHECK_BALANCE}
              </button>
            </div>
          </div>
        </div>
      </FullWithModal>
    </div>
    }
    </>
  ) : showBalanceScreen && giftCardBalanceInfo ? (
    <GiftCardBalanceScreen
      giftCardInfo={giftCardBalanceInfo}
      onDontUse={() => {
        setShowBalanceScreen(false);
        setInputs({ cardNumber: "", securityCode: "", giftCard: "" });
        setTyped({ cardNumber: "", securityCode: "", giftCard: "" });
        previousBalanceInfoRef.current = null;
        handleGiftCancel(true);
      }}
      onRedeem={() => {
        const applyData = {
          cardNumber: giftCardBalanceInfo.accountNumber,
          ...(isSecurityCode && giftCardBalanceInfo.securityCode ? { securityCode: giftCardBalanceInfo.securityCode } : {}),
          method: giftCardBalanceInfo?.method || giftCardNumber?.method || 'type',
          fromBalanceScreen: true
        };
        onSubmit(applyData);
      }}
      serverAppTheme={serverAppTheme}
      currencySymbol={currencySymbol}
      landscapePaymentMode={paymentLandscapeOrientation}
      showCheckSeat={showCheckSeat}
    />
  ) : (
    <>
      <div className="col-12 py-2">
        {giftBalance && (
          <div className="text-left fs-30">
            {LABEL().BALANCE} {currencySymbol}
            {giftBalance.toFixed(2)}
          </div>
        )}
        <div className="large-input my-2 position-relative">
          <input
            value={getInput("giftCard")}
            className={cn("form-control p-1")}
            type="text"
            style={{ height: "10vh", fontSize: "3vh" }}
            id="giftCard"
            name="giftCard"
            onFocus={() => {
              setActiveElement("giftCard");
              handleBlurForGift();
            }}
            placeholder=""
          />
          {inputs?.giftCard?.length > 0 && (
            <div
              role="presentation"
              className="position-absolute"
              style={{ right: "18px", top: "18px" }}
              onClick={() => {
                setEmpty("giftCard");
                setActiveElement("giftCard");
              }}
            >
              <i
                className="fa fa-times fs-24 text-white"
                aria-hidden="true"
              />
            </div>
          )}
          <div className={cn("position-absolute", Styles.currencyDollar)}>
            {currencySymbol}
          </div>
          <div className="col-12 fs-12 text-center">
            {error}
          </div>
        </div>
        <Keyboard
          onClickBtn={onClickBtn}
          type="withoutDone"
          isDot
          typed={typed[activeElement] || ""}
          btnSize="btn80"
          customClass="fs-30"
          maxLength={activeElement === "cardNumber" ? 20 : 10}
        />
      </div>
      <div className="col-12 w-100">
        <button
          type="submit"
          disabled={handleDisableGiftCard()}
          className={cn(
            "col-12 btn70 btn btn-ripple",
            Styles.divForPayment,
          )}
          onClick={() => validate()}
          style={{
            marginTop: "150px",
            fontSize: isServerApp ? "35px" : "17px",
          }}
        >
          {LABEL().CONTINUE}
        </button>
      </div>
    </>
  );
};

const mapStateToProps = ({payment}) => ({
  paymentLandscapeOrientation: payment.paymentLandscapeOrientation
})

const MemoizedGiftCard = memo(giftCard);

export default connect(mapStateToProps)(MemoizedGiftCard);
